import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Funcionario } from '../../api.service';
import { BuscaPesquisavelComponent } from '../../shared/busca-pesquisavel.component';

@Component({
  selector: 'app-seletor-funcionario-existente',
  standalone: true,
  imports: [BuscaPesquisavelComponent],
  templateUrl: './seletor-funcionario-existente.component.html',
  host: { class: 'd-block' }
})
export class SeletorFuncionarioExistenteComponent {
  @Input() termo = '';
  @Input() funcionarios: Funcionario[] = [];
  @Input() rotuloItem: (item: unknown) => string = () => '';
  @Input() detalheItem: (item: unknown) => string = () => '';

  @Output() termoChange = new EventEmitter<string>();
  @Output() buscar = new EventEmitter<void>();
  @Output() selecionar = new EventEmitter<unknown>();
}
